/**
 * systems/net.ts — v4 cleanup: typed, minimal, no dead code
 */

const PID_KEY = "doorpost.presenceId";

export function presenceId(): string {
  let id = localStorage.getItem(PID_KEY);
  if (!id) {
    id = crypto.randomUUID?.() ?? `p-${Date.now()}-${Math.random()}`;
    localStorage.setItem(PID_KEY, id);
  }
  return id;
}

export async function beatPresence(zone: string | null): Promise<number> {
  try {
    const res = await fetch("/api/presence", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: presenceId(), zone }),
    });
    const data = (await res.json()) as { online?: number };
    return data.online ?? 1;
  } catch {
    return 1;
  }
}

export type PeeringInfo = {
  name: string | null;
  info_prefixes4: number | null;
  info_prefixes6: number | null;
  policy_general: string | null;
};

export async function fetchPeering(): Promise<PeeringInfo | null> {
  try {
    const res = await fetch("/api/peering/133555");
    if (!res.ok) return null;
    return (await res.json()) as PeeringInfo;
  } catch {
    return null;
  }
}

export async function fetchEdgeHistory(): Promise<
  Array<{ colo: string | null; rtt_ms: number | null; created_at: string }>
> {
  try {
    const res = await fetch("/api/edge/history");
    const data = (await res.json()) as {
      items?: Array<{ colo: string | null; rtt_ms: number | null; created_at: string }>;
    };
    return data.items ?? [];
  } catch {
    return [];
  }
}

export async function fetchStatusSnippet(): Promise<string | null> {
  try {
    const res = await fetch("/api/status");
    if (!res.ok) return null;
    const data = (await res.json()) as {
      overall?: string;
      services?: Array<{ slug: string; status: string }>;
    };
    const overall = data.overall ?? data.services?.[0]?.status ?? null;
    return overall;
  } catch {
    return null;
  }
}

export async function postEdgeSample(sample: {
  colo: string | null;
  rttMs: number | null;
  asn: number | null;
  country: string | null;
}): Promise<void> {
  try {
    await fetch("/api/edge/sample", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(sample),
    });
  } catch {
    /* ignore */
  }
}
